import React from "react";
import { useCustomQuery } from "utilities/hookutils";
import DocumentReminderPanel from "./DocumentReminderPanel";
import moment from "moment";
import { Reminder } from "./models";
import InvoiceReminderRowCard from "./InvoiceReminderCard";

interface Props {
  document: server.dto.InvoiceV2;
  initialReminders: server.dto.InvoiceReminder[]
}

export const InvoiceReminderApp = (props: Props) => {
  const remindersQuery = useCustomQuery({
    queryKey: ["invoice-reminders", props.document.documentId],
    queryFn: () => window.CoreApi.InvoiceV2.ListReminders(props.document.documentId).then(r => r.data.data),
    initialData: props.initialReminders,
  });

  const deleteAllReminders = () => window.CoreApi.InvoiceV2.DeleteAllReminders(props.document.documentId);

  const addReminder = (days: number) => window.CoreApi.InvoiceV2.AddReminder({
    documentId: props.document.documentId,
    daysAfterDueDate: days,
  });

  const updateReminder = (days: number, reminderNr: number) => window.CoreApi.InvoiceV2.UpdateReminder({
    documentId: props.document.documentId,
    daysAfterDueDate: days,
    type: ("reminder" + reminderNr) as server.dto.DocumentReminderTypes,
  });

  const clearLastReminder = () => window.CoreApi.InvoiceV2.DeleteLastReminder(props.document.documentId)


  const dueMoment = (props.document.lifeCycle.value === "draft" || props.document.lifeCycle.value === "review")
    ? moment.utc().startOf("day").add(props.document.dueInDays, "days")
    : moment.utc(props.document.sendDate).add(props.document.dueInDays, "days");
  const canClearAll = props.document.lifeCycle.value !== "completed" && remindersQuery.data.some(reminder => !reminder.isSent);
  const canDisplayAddNewReminder = props.document.lifeCycle.value !== "completed" && remindersQuery.data.length < serverReference.constants.invoice.maxReminders

  const reminders = remindersQuery.data.map<Reminder>(reminder => ({
    days: reminder.daysAfterDueDate,
    reminderNr: reminder.type.number,
    isSent: reminder.isSent,
  }));


  return <DocumentReminderPanel
    maxDaysAfterSendDate={serverReference.constants.invoice.maxReminderInterval}
    documentSendMoment={dueMoment}
    reminders={reminders}
    clearLastReminder={clearLastReminder}
    renderCard={(reminder, setEditingReminder, clearLastReminder, isLast) => <InvoiceReminderRowCard
      key={reminder.reminderNr}
      value={reminder}
      dueMoment={dueMoment}
      isLast={isLast}
      documentLifeCycle={props.document.lifeCycle.value}
      onClearLastReminder={clearLastReminder}
      onReminderEdit={setEditingReminder}
    />}

    deleteAllReminders={deleteAllReminders}
    addReminder={addReminder}
    updateReminder={updateReminder}
    refetch={remindersQuery.refetch}

    canClearAll={canClearAll}
    canDisplayAddNewReminder={canDisplayAddNewReminder}

  />
}